import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { keyframes } from '@emotion/react';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

const AccessDenied = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        p: 3,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            bgcolor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
            borderRadius: 4,
            p: { xs: 4, md: 8 },
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
          }}
        >
          <Box
            sx={{
              animation: `${float} 3s ease-in-out infinite`,
              mb: 4,
              display: 'inline-block',
            }}
          >
            <ErrorOutlineIcon
              sx={{
                fontSize: 100,
                color: '#ff6b6b',
                filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))',
              }}
            />
          </Box>
          
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 800,
              color: '#2d3436',
              mb: 2,
              fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
              letterSpacing: '-0.5px',
            }}
          >
            Access Denied
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              color: '#636e72',
              mb: 4,
              fontSize: '1.1rem',
              lineHeight: 1.6,
            }}
          >
            We're sorry, but it looks like you're missing a required ID to access this page. Please check your link and try again.
          </Typography>

        </Box>
      </Container>
    </Box>
  );
};

export default AccessDenied;
